/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { createContext, type ForwardedRef, forwardRef, type ReactElement } from 'react';
import { type ContextValue, GridList as GridListCore, type GridListProps as GridListCoreProps, useContextProps } from 'react-aria-components';

interface GridListProps<T> extends Omit<GridListCoreProps<T>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const GridListContext = createContext<ContextValue<GridListProps<object>, HTMLDivElement>>({});

const GridList = forwardRef((props: GridListProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, GridListContext);

  const { style, children, ...coreProps } = props;

  return (
    <GridListCore
      ref={ref}
      {...stylex.props(styles.base, style)}
      {...coreProps}>
      {children}
    </GridListCore>
  );
}) as <T>(p: GridListProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    outline: 'none',
    overflow: 'auto',
    boxSizing: 'border-box',
    maxHeight: 'inherit',
  },
});

export { GridList, GridListContext, type GridListProps };
